package org.example.zone360.pages.coachDetails.sessionAllDetails.sessionEmphasis

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.browser.window
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSessionKeywordsData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.SessionDataDetailsResponse
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import kotlin.math.roundToInt

@Composable
fun SessionEmphasisBreakdown(
    keywords: List<GetSessionKeywordsData>,
    sitePalette: SitePalette,
    breakpoint: Breakpoint,
    isEmotionLoading: Boolean
) {

   val categoryCounts = keywords
       .groupBy { it.keywordCategory.trim().lowercase() }
       .mapValues { (_, values) -> values.sumOf { it.usageCount } }


    val totalKeywordCount = categoryCounts.values.sum()
    val displayCategories = listOf(
        "technical" to Res.Images.technical,
        "fitness" to Res.Images.fitness,
        "tactical" to Res.Images.tactical,
        "mental" to Res.Images.mental,
        "goalkeeper" to Res.Images.goalkeeper,
        "custom" to Res.Images.football_LowScale
    )

    Column(
        modifier = Modifier.fillMaxWidth()
            .then(
                if (window.screen.width > 600) Modifier.height(208.px) else Modifier
            )
            .margin(top = 15.px)
            .borderRadius(12.px)
            .border(
                1.px,
                style = LineStyle.Solid,
                color = sitePalette.coachDetailsBoxBorder.rgb
            )
            .overflow(overflowX = Overflow.Auto, overflowY = Overflow.Hidden)
            .padding(16.px)
    ) {
        Column (modifier = Modifier.width(
                 100.percent

        )){
            SectionTitle("Emphasis Breakdown", bottom = if (window.screen.width > 600) 0.px else 10.px)
            Row(
                modifier = Modifier.fillMaxWidth().gap(10.px)
                    .flexWrap(if (window.screen.width > 600) FlexWrap.Nowrap else FlexWrap.Wrap),
                horizontalArrangement = if (breakpoint < Breakpoint.MD) Arrangement.Center else Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (isEmotionLoading) {
                    Box(
                        modifier = Modifier.width(200.px)
                            .height(150.px),
                        contentAlignment = Alignment.Center
                    ) {
                        ProgressIndicator()
                    }
                } else {
                    Row(modifier = Modifier.width(300.px)
                        .rowGap(15.px)
                        .flexWrap(FlexWrap.Wrap)) {
                        displayCategories.forEach { (categoryKey, imageUrl) ->
                            val count = when (categoryKey) {
                                "custom" -> categoryCounts.filterKeys {
                                    it !in listOf(
                                        "technical",
                                        "fitness",
                                        "tactical",
                                        "mental",
                                        "goalkeeper"
                                    )
                                }.values.sum()

                                else -> categoryCounts[categoryKey] ?: 0
                            }
                            val percentage: Int = if (totalKeywordCount > 0) {
                                ((count.toDouble() / totalKeywordCount) * 100).toInt()
                            } else {
                                0
                            }

                            Row(modifier = Modifier.width(50.percent),
                                verticalAlignment = Alignment.CenterVertically,
                            ) {
                                Image(
                                    src = imageUrl,
                                    modifier = Modifier.size(20.px).margin(right = 8.px)
                                )
                                FieldTitleTextNormalSimple(
                                    text = "${categoryKey.replaceFirstChar { it.uppercase() }} ($percentage%)",
                                    fontSize = 13.px
                                )
                            }
                        }
                    }
                    Column(Modifier.margin(bottom = 10.px),
                        horizontalAlignment = Alignment.CenterHorizontally) {
                        SpeakingDonutChart(
                            keywords = keywords,
                            sitePalette = sitePalette
                        )
                    }

                }
            }

        }
    }
}